<template>
  <div>
    <v-container grid-list-xl class="pa-5">
      <m-breadcrum :items="bread"></m-breadcrum>
      <m-card style="position: relative" title="Statistik Kuesioner">
        <template v-slot:action_tools>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="modal = true"><v-icon>mdi-filter</v-icon></v-btn>
            </template>
            <span>Filter</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-if="canDownload" icon v-on="on" @click="onDownload"
                ><v-icon>mdi-download</v-icon></v-btn
              >
            </template>
            <span>Unduh Jawaban</span>
          </v-tooltip>
        </template>
        <div
          class="py-3 px-2"
          v-if="getDeepObj(filters, 'wkt_mulai') || getDeepObj(filters, 'wkt_selesai')"
          style="background-color: #f6f7fb"
        >
          <span class="black--text pr-2">Hasil Filter:</span>
          <v-chip outlined color="grey">
            <span class="black--text">
              {{ getDeepObj(filters, 'wkt_mulai') | toDT }}
              <span v-if="getDeepObj(filters, 'wkt_selesai')">
                &nbsp;-&nbsp;
                {{ getDeepObj(filters, 'wkt_selesai') | toDT }}
              </span>
            </span>
            <v-icon right small style="cursor: pointer" @click="onReset">mdi-close-circle</v-icon>
          </v-chip>
        </div>
        <v-container class="px-0 black--text">
          <div class="d-flex justify-space-between">
            <div>
              <div class="text-h6 font-weight-regular">
                {{ getDeepObj(detail, 'nama') }}
              </div>
              <div>
                {{ getDeepObj(detail, 'deskripsi') }}
              </div>
              <div class="my-2">
                <v-icon left small>mdi-clock-outline</v-icon> Aktif
                <i
                  >{{ getDeepObj(detail, 'wkt_mulai') | toSDNF }} s/d
                  {{ getDeepObj(detail, 'wkt_selesai') | toSDNF }}</i
                >
                <v-icon class="ml-4" right small>mdi-calendar</v-icon>
                {{ M_PERIOD[Number(getDeepObj(detail, 'k_tipe_pengisian') || 1)] }}
              </div>
            </div>
            <div>
              <v-chip :color="M_STATUS[Number(getDeepObj(detail, 'status_tayang') || 1)]['color']" outlined>
                {{ M_STATUS[Number(getDeepObj(detail, 'status_tayang') || 1)]['text'] }}
              </v-chip>
            </div>
          </div>

          <v-row class="mt-4">
            <v-col cols="12" md="8" sm="12" class="pa-0">
              <v-card class="pa-0">
                <v-card-text class="black--text">
                  <div class="text-h6 font-weight-regular">Detail Responden Terhadap Kuesioner</div>
                  <div
                    ><v-icon left>mdi-account-group</v-icon>
                    {{ getDeepObj(detail, 'statistik.jumlah') || 0 }} Responden</div
                  >
                  <MChartPie
                    :op-data="statisik"
                    :op-config="{
                      left: '42%',
                      top: '40%',
                      center: ['20%', '50%', '40%'],
                      color: ['#4CAF50', '#FF9800', '#F44336'],
                    }"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <v-card class="pa-2">
                <v-card-text class="black--text">
                  <div class="text-h6 font-weight-regular">Total Responden</div>
                  <div class="mt-2">
                    <span class="text-h4 font-weight-medium">{{ getDeepObj(detail, 'statistik.jumlah') || 0 }}</span>
                    <span class="ml-2">Responden</span>
                  </div>
                </v-card-text>
              </v-card>
              <v-alert class="green lighten-5 mt-2" outlined type="success" prominent colored-border border="left">
                <template v-slot:prepend>
                  <v-icon color="success">mdi-check-circle</v-icon>
                </template>
                <div class="d-flex justify-space-between">
                  <span class="mt-2 ml-2 success--text">Mengisi <b>Lengkap</b></span>
                  <span class="text-h4 success--text font-weight-medium">{{
                    getDeepObj(detail, 'statistik.final') || 0
                  }}</span>
                </div>
              </v-alert>
              <v-alert class="orange lighten-5 mt-2" outlined type="warning" prominent colored-border border="left">
                <template v-slot:prepend>
                  <v-icon color="orange">mdi-check-circle</v-icon>
                </template>
                <div class="d-flex justify-space-between">
                  <span class="mt-2 ml-2 warning--text">Mengisi <b>Tidak Lengkap</b></span>
                  <span class="text-h4 warning--text font-weight-medium">{{
                    getDeepObj(detail, 'statistik.draft') || 0
                  }}</span>
                </div>
              </v-alert>
              <v-alert class="red lighten-5 mt-2" outlined type="red" prominent colored-border border="left">
                <template v-slot:prepend>
                  <v-icon color="red">mdi-check-circle</v-icon>
                </template>
                <div class="d-flex justify-space-between">
                  <span class="mt-2 ml-2 red--text"><b>Belum</b> Mengisi</span>
                  <span class="text-h4 red--text font-weight-medium">{{
                    getDeepObj(detail, 'statistik.baru') || 0
                  }}</span>
                </div>
              </v-alert>
            </v-col>
            <v-col class="mt-3" cols="12" md="12" sm="12">
              <m-card-list
                class="ma-n3"
                descLock=""
                two-line
                title="Daftar Responden"
                label-cari="Cari Responden"
                search
                :headers="headers"
                :items="items"
                refresh
                @refresh="load"
                :page="page"
                footer
                @search="
                  (search) => {
                    textSearch = search
                    page = 1
                    load()
                  }
                "
                @change:page="
                  (pg) => {
                    cp = pg
                    load()
                  }
                "
              >
                <template v-slot:items="{ props, item }">
                  <tr>
                    <td v-for="(head, h) in headers" :key="h" :width="head.width">
                      <div v-if="head.name === 'nama'" class="my-5">
                        <div style="font-weight: bold"> {{ getDeepObj(item, 'users.nama') }}</div>
                        <div class="small" v-if="item.wkt_selesai">
                          {{ getDeepObj(item, 'wkt_selesai') | toDT }}
                        </div>
                      </div>
                      <template v-if="head.name === 'status'">
                        <v-chip
                          v-if="Number(getDeepObj(item, 'k_status_kuesioner')) === 6"
                          outlined
                          small
                          color="success"
                        >
                          <v-icon left small>mdi-check-circle</v-icon> Mengisi Lengkap
                        </v-chip>
                        <v-chip
                          v-else-if="[1, 5].includes(Number(getDeepObj(item, 'k_status_kuesioner')))"
                          outlined
                          small
                          color="warning"
                        >
                          <v-icon left small>mdi-alert</v-icon> Tidak Lengkap
                        </v-chip>
                        <v-chip v-else outlined small color="red">
                          <v-icon left small>mdi-information</v-icon> Belum Mengisi
                        </v-chip>
                      </template>
                      <template v-if="head.name === 'wkt_pengisian'">
                        <span v-if="getDeepObj(item, 'wkt_selesai')" class="caption success--text">
                          <v-icon small left color="success">mdi-check</v-icon>Sudah Mengirim
                        </span>
                        <span v-else class="caption red--text">
                          <v-icon small left color="red">mdi-information</v-icon>Belum Mengirim
                        </span>
                        <div class="black--text caption"> {{ getDeepObj(item, 'wkt_selesai') | toDT }}</div>
                      </template>
                      <template v-else>
                        <div v-html="getJawaban(item, head.id)" />
                      </template>
                    </td>
                  </tr>
                </template>
              </m-card-list>
            </v-col>
          </v-row>
        </v-container>
      </m-card>
      <v-dialog v-model="modal" max-width="600px">
        <v-card>
          <v-card-title class="headline primary white--text">
            <v-icon class="mr-3 white--text">mdi-filter-variant</v-icon>
            <slot name="title"> Filter Berdasarkan </slot>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-0" style="height: 250px">
            <div class="text-h6 my-2 mb-5 font-weight-regular black--text'"
              >Pilih rentan waktu yang akan ditampilkan</div
            >
            <v-row>
              <v-col cols="12" md="12" sm="12" class="py-0">
                <span class="grey--text"> Tanggal Awal</span>
                <m-date-time-picker
                  v-model="filters.wkt_mulai"
                  prepend-inner-icon="mdi-calendar"
                  placeholder="Waktu Mulai"
                />
              </v-col>
              <v-col cols="12" md="12" sm="12" class="py-0">
                <span class="grey--text"> Tanggal Akhir</span>
                <m-date-time-picker
                  v-model="filters.wkt_selesai"
                  prepend-inner-icon="mdi-calendar"
                  placeholder="Waktu Selesai"
                  :min="filters.wkt_mulai"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mb-5"></v-divider>
          <v-card-actions class="pr-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn depressed text color="warning" @click="onReset"> Reset Filter </v-btn>
            <v-btn name="simpan" depressed color="primary" @click="onFilter">
              <v-icon>mdi-check</v-icon>Terapkan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import MChartPie from '@/components/MChartPie.vue'
import MDateTimePicker from '@/components/MDateTimePicker.vue'
import { M_STATUS } from '@/modules/kuesioner/const'

export default {
  components: { MChartPie, MDateTimePicker },
  data() {
    return {
      textSearch: '',
      cp: 1,
      page: null,
      items: [],
      detail: {},
      modal: false,
      filters: {},
      isInit: false,
      M_STATUS: M_STATUS,
      M_PERIOD: {
        1: '1x Pengisian',
        2: 'Harian',
        3: 'Mingguan',
        4: 'Bulanan',
      },
    }
  },
  computed: {
    headers() {
      let temp = [
        { text: 'Nama Responden', align: 'left', tipe: 'static', name: 'nama', width: '15%', sortable: false },
        { text: 'Status', align: 'left', tipe: 'static', name: 'status', width: '15%', sortable: false },
      ]
      const soals = this.getDeepObj(this.detail, 'kuesioner_soals') || []
      soals.forEach((item) => {
        temp.push({
          text: item.label,
          sortable: false,
          id: item.kuesioner_soal_id,
        })
      })
      return temp
    },

    statisik() {
      return [
        {
          value: Number(this.getDeepObj(this.detail, 'statistik.final') || 0),
          name: 'Mengisi Lengkap',
        },
        {
          value: Number(this.getDeepObj(this.detail, 'statistik.draft') || 0),
          name: 'Mengisi Tidak Lengkap',
        },
        {
          value: Number(this.getDeepObj(this.detail, 'statistik.baru') || 0),
          name: 'Belum Mengisi',
        },
      ]
    },
    id() {
      return this.getDeepObj(this.$route, 'params.kuesioner_id')
    },
    orgsId() {
      return this.getDeepObj(this.$route, 'params.organisasi_id')
    },
    tenantId() {
      return this.getDeepObj(this.$route, 'params.tenant_id')
    },
    isTenantScope() {
      return (this.$route.name || '').indexOf('tenant-') === 0
    },
    scopeId() {
      return this.isTenantScope ? this.tenantId : this.orgsId
    },
    scopePayload() {
      return {
        organisasi_id: this.scopeId,
        is_tenant: this.isTenantScope,
      }
    },
    canDownload() {
      return this.isTenantScope ? this.isCan('tenant-kuesioner.index') : this.isCan('kuesioner.download')
    },
    bread() {
      return [
        {
          icon: 'mdi-home',
          title: 'Kuesioner',
          to: {
            name: this.isTenantScope ? 'tenant-kuesioner' : 'kuesioner',
            params: this.isTenantScope ? { tenant_id: this.scopeId } : { organisasi_id: this.scopeId },
          },
        },
        {
          title: this.getDeepObj(this.detail, 'nama'),
        },
      ]
    },
  },
  activated() {
    this.getDetail()
  },
  methods: {
    load() {
      this.$store
        .dispatch('kuesioner/getResponden', Object.assign({}, this.scopePayload, {
          kuesioner_id: this.id,
          params: Object.assign(
            {},
            {
              page: this.cp,
              keyword: this.textSearch,
            },
            this.filters
          ),
        }))
        .then((res) => {
          this.page = res.data
          this.items = res.data.data || res.data || []
        })
        .catch((e) => e)
    },

    getJawaban(item, id) {
      const jawaban = this.getDeepObj(item, `kuesioner_jawabans`) || []

      const filters = jawaban.filter((j) => j.kuesioner_soal_id === id) || []

      if (filters.length === 0) return ''

      if (filters.length > 1) {
        return `<ul class="pa-0 ma-0">
          ${filters.map(j => `<li>${j.teks}${j.catatan ? ` (${j.catatan})` : ''}</li>`).join('')}
        </ul>`
      } else {
        const single = filters[0] || {}
        return `${single.teks || ''}${single.catatan ? ` (${single.catatan})` : ''}`
      }
    },

    getDetail() {
      if (!this.id) return

      if (!this.isInit) {
        this.$set(this.filters, 'wkt_mulai', new Date().toISOString().slice(0, 10) + ' 00:01:00')
        this.$set(this.filters, 'wkt_selesai', new Date().toISOString().slice(0, 10) + ' 23:59:59')
        this.isInit = true
      }

      const params = {
        wkt_mulai: this.getDeepObj(this.filters, 'wkt_mulai'),
        wkt_selesai: this.getDeepObj(this.filters, 'wkt_selesai'),
      }

      this.$store
        .dispatch('kuesioner/actions', Object.assign({}, this.scopePayload, {
          id: this.id,
          type: 'get',
          api: 'statistik',
          params: params,
        }))
        .then(({ data }) => {
          this.detail = (data && data.data) || {}
        })
        .then(() => {
          this.load()
        })
    },
    onFilter() {
      this.getDetail()
      this.modal = false
    },
    onDownload() {
      this.$store
        .dispatch('kuesioner/download', Object.assign({}, this.scopePayload, {
          id: this.id,
          params: this.filters,
        }))
        .then((url) => {
          window.open(url, '_blank')
        })
    },
    onReset() {
      this.$set(this, 'filters', {})
      this.getDetail()
      this.modal = false
    },
  },
}
</script>
